import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 103.8 105.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M38.6 52.6c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5S58 65.1 51.1 65.1c-6.9.1-12.5-5.6-12.5-12.5M51.1 0C26.5 0 5.9 16.8.1 39.6c0 .2-.1.3-.1.5 0 1.4 1.1 2.5 2.5 2.5h21.2c1 0 1.9-.6 2.3-1.5C30.4 31.6 39.9 25 51.1 25c15.2 0 27.6 12.4 27.6 27.6S66.3 80.2 51.1 80.2C40 80.2 30.4 73.6 26 64.1c-.4-.9-1.3-1.5-2.3-1.5H2.5c-1.4 0-2.5 1.1-2.5 2.5 0 .2 0 .3.1.5 5.8 22.8 26.4 39.6 51 39.6 29.1 0 52.7-23.6 52.7-52.7 0-29-23.6-52.5-52.7-52.5",
      style: {"fill":"#343434"}
    }, null, -1)
  ])))
}
export default { render: render }